import type { AxiosError } from "axios";

import * as Sentry from "@sentry/react";

import { ifAxiosErrorAddContext } from "@virtual-brain-lib/utils-common";

export const sentryDefaultConfiguration: Sentry.BrowserOptions = {
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.browserProfilingIntegration(),
		Sentry.replayIntegration(),
	],
	tracePropagationTargets: [
		"localhost",
		/^https:\/\/api\.getvirtualbrain\.com/,
		/^https:\/\/content-api\.getvirtualbrain\.com/,
		/^https:\/\/chatbot-api\.getvirtualbrain\.com/,
	],
	// Performance Monitoring
	tracesSampleRate: 0.1, // Capture 10% of the transactions, reduce in production!
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the replay sample rate at 10%
	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	beforeSend(event, hint) {
		if (hint?.originalException) {
			event.contexts = ifAxiosErrorAddContext(
				event.contexts,
				hint.originalException as AxiosError,
			);

			// We ignore disconnection or end of cookie time errors from the front, or network errors
			if (
				event.contexts?.errorResponse?.status === 401 ||
				event.contexts?.errorResponse?.message === "Network Error"
			) {
				return null;
			}
		}

		event.release = "v2026.11.05.2";

		return event;
	},
};
